import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    invite: {
      body: 'Hello,\nI found the ideal business account for your activity: 100% online, 100% customizable, 100% secure, with a customer service available 7/7. Open your account with my link and enjoy 2 months free:\n\n\n{0}',
      subject: 'The ideal business account for your activity',
    },
    inviteByEmail: 'Invite by email',
  },
  fr: {
    invite: {
      body: "Hello,\nJ'ai trouvé le compte pro idéal pour ton activité : 100% en ligne, 100% paramétrable, 100% sécurisé, avec un service client dispo 7j/7. Ouvre ton compte avec mon lien et profite de 2 mois gratuits :\n\n\n{0}",
      subject: 'Le compte pro idéal pour ton activité',
    },
    inviteByEmail: 'Inviter par e-mail',
  },
} as const);

export default locales;
